import KeyboardService from '@/services/KeyboardService'


export const state = {
  keyboard: {},
}
export const mutations = {

  setKeyboard(currentState, keyboard) {
    currentState.keyboard.keyboard = keyboard
  },
}
export const actions = {
  getKeyboard({ rootState, commit }) {
    if (rootState.keyboard.keyboard.poisson) { return }
    KeyboardService.getKeyboard().then((keyboard) => {
      commit('setKeyboard', keyboard)
    })
  },

}
export default { state, actions, mutations }
